<template>
  <div id="addQuestionView">
    <h2 style="margin-bottom: 32px">设置题目</h2>
    <a-form
      :model="questionContent"
      :style="{ width: '480px' }"
      auto-label-width
      @submit="handleSubmit"
    >
      <a-form-item label="应用 id">
        {{ appId }}
      </a-form-item>
      <a-form-item label="题目列表" :content-flex="false" :merge-props="false">
        <a-space size="medium">
          <a-button @click="addQuestion(questionContent.length)">
            底部添加题目
          </a-button>
          <!-- AI 生成 -->
          <ai-generate-question-drawer
            :appId="appId"
            :onSuccess="onAiGenerateSuccess"
            :onSSESuccess="onAiGenerateSuccessSSE"
            :onSSEClose="onSSEClose"
            :onSSEStart="onSSEStart"
          />
        </a-space>
        <!-- 遍历每道题目 -->

        <div v-for="(question, index) in questionContent" :key="index">
          <!-- 折叠 -->
          <a-collapse :default-active-key="[index + 1]" destroy-on-hide>
            <a-collapse-item :header="`题目 ${index + 1}`" :key="index">
              <template #extra>
                <a-button
                  size="small"
                  status="danger"
                  @click="deleteQuestion(index)"
                >
                  删除题目
                </a-button>
              </template>

              <a-form-item field="posts.post1" label="问题">
                <a-input
                  v-model="question.title"
                  placeholder="请输入题目标题"
                />
              </a-form-item>

              <!-- 题目选项 -->
              <a-space size="large">
                <h4>选项列表</h4>
                <a-button
                  size="small"
                  @click="
                    addQuestionOption(question, question.options?.length!)
                  "
                >
                  底部添加选项
                </a-button>
              </a-space>
              <a-form-item :content-flex="false" :merge-props="false">
                <a-collapse
                  v-for="(option, optionIndex) in question.options"
                  :key="optionIndex"
                  :default-active-key="['1.' + optionIndex]"
                  destroy-on-hide
                >
                  <a-collapse-item
                    :header="`选项 ${optionIndex + 1}`"
                    :key="['1.' + optionIndex]"
                  >
                    <template #extra>
                      <a-button
                        size="mini"
                        status="danger"
                        @click="
                          deleteQuestionOption(question, optionIndex as any)
                        "
                      >
                        删除选项
                      </a-button>
                    </template>
                    <a-form-item label="选项 key">
                      <a-input
                        v-model="option.key"
                        placeholder="请输入选项 key"
                      />
                    </a-form-item>
                    <a-form-item label="选项值">
                      <a-input
                        v-model="option.value"
                        placeholder="请输入选项值"
                      />
                    </a-form-item>
                    <a-form-item label="选项结果">
                      <a-input
                        v-model="option.result"
                        placeholder="请输入选项结果"
                      />
                    </a-form-item>
                    <a-form-item label="选项得分">
                      <a-input-number
                        v-model="option.score"
                        placeholder="请输入选项得分"
                      />
                    </a-form-item>
                  </a-collapse-item>
                </a-collapse>
              </a-form-item>
              <!-- 题目选项末尾 -->
            </a-collapse-item>
          </a-collapse>
        </div>
      </a-form-item>
      <a-button type="primary" html-type="submit" style="width: 120px">
        提交
      </a-button>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import message from "@arco-design/web-vue/es/message";
//@ts-ignore
import { withDefaults, defineProps, ref, watchEffect } from "vue";
import API from "@/api";
import { useRouter } from "vue-router";
import {
  addQuestionUsingPost,
  editQuestionUsingPost,
  listQuestionVoByPageUsingPost,
} from "@/api/questionController";
import AiGenerateQuestionDrawer from "./components/AiGenerateQuestionDrawer.vue";

interface Props {
  appId: string;
}

const props = withDefaults(defineProps<Props>(), {
  appId: () => {
    return "";
  },
});

// 题目结构定义
const questionContent = ref<API.QuestionContentDTO[]>([]);

// 添加题目

const addQuestion = (index: number) => {
  questionContent.value.splice(index, 0, {
    title: "",
    options: [],
  });
};

// 删除题目

const deleteQuestion = (index: number) => {
  questionContent.value.splice(index, 1);
};

/**
 * 添加题目选项
 * @param question
 * @param index
 */
const addQuestionOption = (question: API.QuestionContentDTO, index: number) => {
  if (!question.options) {
    question.options = [];
  }
  question.options.splice(index, 0, {
    key: "",
    value: "",
  });
};

// 删除题目选项

const deleteQuestionOption = (
  question: API.QuestionContentDTO,
  index: number
) => {
  if (!question.options) {
    question.options = [];
  }
  question.options.splice(index, 1);
};

const router = useRouter();

const oldQuestion = ref<API.QuestionVO>();

// 加载数据
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  const res = await listQuestionVoByPageUsingPost({
    appId: props.appId as any,
    current: 1,
    pageSize: 1,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.data.code === 0 && res.data.data?.records) {
    oldQuestion.value = res.data.data?.records[0];
    if (oldQuestion.value) {
      questionContent.value = oldQuestion.value.questionContent ?? [];
    }
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听变量：触发加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 提交表单
 */
const handleSubmit = async () => {
  if (!props.appId || !questionContent.value) {
    return;
  }
  let res: any;
  //编辑
  if (oldQuestion.value?.id) {
    res = await editQuestionUsingPost({
      id: oldQuestion.value.id,
      questionContent: questionContent.value,
    });
  } else {
    //创建
    res = await addQuestionUsingPost({
      appId: props.appId as any,
      questionContent: questionContent.value,
    });
  }
  if (res.data.code === 0) {
    message.success("操作成功, 正在跳转到详情页...");
    setTimeout(() => {
      router.push(`/app/detail/${props.appId}`);
    }, 3000);
  } else {
    message.error("操作失败，" + res.data.message);
  }
};

/**
 * AI 生成题目成功回调
 * @param result
 */
const onAiGenerateSuccess = (result: API.QuestionContentDTO[]) => {
  message.success(`AI 生成题目成功，生成 ${result.length} 道题目`);
  questionContent.value = [...questionContent.value, ...result];
};

/**
 * AI 生成题目成功回调（SSE）
 */
const onAiGenerateSuccessSSE = (result: API.QuestionContentDTO) => {
  questionContent.value = [...questionContent.value, result];
};

/**
 * SSE 开始生成
 * @param event
 */
const onSSEStart = (event: any) => {
  message.success("开始生成");
};

/**
 * SSE 生成完毕
 * @param event
 */
const onSSEClose = (event: any) => {
  message.success("生成完毕");
};
</script>

<style scoped></style>
